export type DraftStep = {
  key: string;
  id?: number | string;
  dayOffset: number;
  subject: string;
  body: string;
};

export type SavedStep = {
  id: number | string;
};

export type StepWrite = {
  day_offset: number;
  subject: string | null;
  body: string;
  position: number;
};

export function moveDraftStep(
  steps: DraftStep[],
  index: number,
  direction: -1 | 1,
): DraftStep[] {
  const target = index + direction;
  if (target < 0 || target >= steps.length) return steps;
  const next = steps.slice();
  const [item] = next.splice(index, 1);
  next.splice(target, 0, item);
  return next;
}

export function draftStepError(step: DraftStep): string | null {
  if (!Number.isInteger(step.dayOffset) || step.dayOffset < 0) {
    return "Use a whole number of days, starting at 0.";
  }
  if (!step.body.trim()) return "Write the email.";
  return null;
}

export function planStepWrites(saved: SavedStep[], draft: DraftStep[]) {
  const kept = new Set(
    draft.filter((step) => step.id != null).map((step) => String(step.id)),
  );
  const writes = draft.map((step, position) => ({
    id: step.id,
    day_offset: step.dayOffset,
    subject: step.subject.trim() ? step.subject.trim() : null,
    body: step.body.trim(),
    position,
  }));
  return {
    removeIds: saved
      .filter((step) => !kept.has(String(step.id)))
      .map((step) => step.id),
    updates: writes.filter(
      (step): step is StepWrite & { id: number | string } => step.id != null,
    ),
    creates: writes
      .filter((step) => step.id == null)
      .map(({ day_offset, subject, body, position }) => ({
        day_offset,
        subject,
        body,
        position,
      })),
  };
}
